import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c784a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "patientList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "환자 현황", -1))
const _hoisted_3 = { class: "table-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "글 목록", -1))
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h3 class=\"hidden\" data-v-19c784a3>분류</h3><div class=\"tr th\" data-v-19c784a3><span class=\"col1 col-number\" data-v-19c784a3>No.</span><span class=\"col2\" data-v-19c784a3>등록일</span><span class=\"col3\" data-v-19c784a3>환자명</span><span class=\"col4\" data-v-19c784a3>국가</span><span class=\"col5\" data-v-19c784a3>이메일(아이디)</span><span class=\"col6\" data-v-19c784a3>관심 진료질환</span></div><h3 class=\"hidden\" data-v-19c784a3>내용</h3>", 3)
const _hoisted_9 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "err-server"
}
const _hoisted_14 = { class: "err-server-msg" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col1 col-number" }
const _hoisted_17 = { class: "col2" }
const _hoisted_18 = { class: "col3 txt-wrap" }
const _hoisted_19 = { class: "col4 txt-wrap" }
const _hoisted_20 = { class: "col5 txt-wrap" }
const _hoisted_21 = { class: "col6" }
const _hoisted_22 = {
  key: 0,
  class: "subject-list"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "-", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "subject-list"
}
const _hoisted_26 = {
  key: 0,
  style: {"padding":"0 6px 0 0"}
}
const _hoisted_27 = { class: "page-nation-vue" }
const _hoisted_28 = {
  key: 0,
  class: "currentPopup"
}

import { onBeforeMount, onMounted, watch, ref, computed } from 'vue';
import { useStore } from 'vuex';
import BoardSearcher from '@/components/item/BoardSearcher.vue';
import PageNation from '@/components/item/PageNation.vue';
import PatientInfoPopup from '@/views/patient/popup/PatientInfoPopup.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PatientList',
  setup(__props) {

const store = useStore();
const Pt = store.state.modulePt;
/**** data -------------------- */
var exception = computed(() => Pt.exception);
var patientList = computed(() => Pt.patientList);
var totalCount = computed(() => Pt.totalCount);
var propsPageNumber = ref(1);
var pageNumber = ref(1);
var lastPageNumber = computed(() => store.getters['modulePt/getLastPageNumber']);
var rowNumber = ref(8);
var periodEasy = ref('00');
var dateStart = ref('');
var dateEnd = ref('');
var searchType = ref('00');
var searchWord = ref('');
var searchTypes = ref([
  { code: '00', name: '전체' },
  { code: '01', name: '환자명' },
  { code: '02', name: '이메일' },
  { code: '03', name: '진료질환' },
]);
var currentPatient = ref({});
var currentPopup = ref(null);
var isOnListLoading = ref(true);
var popupTitle = ref('');
var popupDesc = ref('');
var paramForList = ref({});
/**** methods ----------------- */
const setPeriodOption = (item: { code: string; name: string }) => {
  periodEasy.value = item.code;
};
const setDates = (start: string, end: string) => {
  dateStart.value = start; // yyyy-MM-dd
  dateEnd.value = end; // yyyy-MM-dd
};
const setSearchType = (item: { code: string; name: string }) => {
  searchType.value = item.code;
};
const setSearchWord = (word: string) => {
  searchWord.value = word;
};
const onClick_searchButton = (word: string) => {
  searchWord.value = word;
  setPatientList(1);
};
const onClick_pageNumber = (num: number) => {
  pageNumber.value = num;
};
const onClick_close = () => {
  currentPopup.value = null;
};
const onClick_item = async (item: object, index: number) => {
  currentPatient.value = await item;
  currentPopup.value = PatientInfoPopup;
};
const setPatientList = async (pNum: number) => {
  pageNumber.value = pNum;
  isOnListLoading.value = true;
  paramForList.value = {
    page: pageNumber.value, // *
    rows: rowNumber.value, // *
    search_period: periodEasy.value, // * 간편 기간 검색
    search_date_begin: dateStart.value, // * yyyy-MM-dd
    search_date_end: dateEnd.value, // * yyyy-MM-dd
    search_text: searchWord.value, // *
    search_type: searchType.value, // * 검색 유형 [00:전체, 01:환자명, 02:국가, 03:아이디/이메일, 04:관심 진료질환 ]
  };
  console.log(paramForList.value);
  await store.dispatch('modulePt/getPatientList', paramForList.value, { root: true });
  setTimeout(() => {
    isOnListLoading.value = false;
  }, 800);
};
/**** content -----------------
 *
 * 환자 현황
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  store.state.modulePt.patientList = [];
});
onMounted(() => {
  setPatientList(1);
});
watch(
  () => pageNumber.value,
  () => {
    setPatientList(pageNumber.value);
  },
  { deep: true }
);
watch(
  () => currentPopup.value,
  (newValue) => {
    if (newValue === null) {
      setPatientList(pageNumber.value);
    }
  },
  { deep: true }
);
watch(
  () => periodEasy.value,
  () => {
    setPatientList(1);
  },
  { deep: true }
);
watch(
  () => dateStart.value,
  () => {
    setPatientList(1);
  },
  { deep: true }
);
watch(
  () => dateEnd.value,
  () => {
    setPatientList(1);
  },
  { deep: true }
);
watch(
  () => pageNumber.value,
  () => {
    propsPageNumber.value = pageNumber.value;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BoardSearcher, {
          "search-types": _unref(searchTypes),
          onSetPeriodOption: setPeriodOption,
          onSetDates: setDates,
          onSetSearchType: setSearchType,
          onSetSearchWord: setSearchWord,
          onOnClick_searchButton: onClick_searchButton
        }, null, 8, ["search-types"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_unref(isOnListLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
          : _createCommentVNode("", true),
        (!_unref(isOnListLoading) && _unref(exception).patientList.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("p", {
                class: _normalizeClass([{ 'err-server-bang': _unref(exception).patientList.type === 'bang' }, { 'err-server-empty': _unref(exception).patientList.type === 'empty' }])
              }, null, 2),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(exception).patientList.desc), 1)
            ]))
          : (!_unref(isOnListLoading) && !_unref(exception).patientList.bool)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(patientList), (item, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  class: "td",
                  key: item
                }, [
                  _createElementVNode("li", {
                    class: "tr",
                    onClick: _withModifiers(($event: any) => (onClick_item(item, index)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(totalCount) - _unref(rowNumber) * (_unref(pageNumber) - 1) - index), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.createdDate), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.patientName), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.nationality), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.idEmail), 1),
                    _createElementVNode("span", _hoisted_21, [
                      (item.diseasesOnSubjects === null)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_22, _hoisted_24))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.diseasesOnSubjects, (subItem, subIndex) => {
                              return (_openBlock(), _createElementBlock("li", { key: subItem }, [
                                _createTextVNode(_toDisplayString(subItem), 1),
                                (item.diseasesOnSubjects.length - 1 !== subIndex)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, ","))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                    ])
                  ], 8, _hoisted_15)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_27, [
        _createVNode(PageNation, {
          "props-page-number": _unref(propsPageNumber),
          "total-count": _unref(totalCount),
          "row-number": _unref(rowNumber),
          "last-page-number": _unref(lastPageNumber),
          onOnClick_pageNumber: onClick_pageNumber
        }, null, 8, ["props-page-number", "total-count", "row-number", "last-page-number"])
      ], 512), [
        [_vShow, !_unref(isOnListLoading) && !_unref(exception).patientList.bool]
      ])
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                "current-patient": _unref(currentPatient),
                onOnClick_close: _cache[0] || (_cache[0] = ($event: any) => (onClick_close()))
              }, null, 40, ["popup-title", "popup-desc", "current-patient"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})